import React from "react";
import PropTypes from "prop-types";
import useOfferStatus from "../../../hooks/useOfferStatus/useOfferStatus";
import TextPill from "../../Pills/TextPill/TextPill";

export default function OfferStatusPill({ value }) {
  const { currentStatus } = useOfferStatus(value);

  return (
    <span>
      {currentStatus &&
        <TextPill
          value={currentStatus.name}
          backgroundColor={currentStatus.backgroundColor}
          color={currentStatus.color}
          padding="2px 6px"
          margin="-4px 0 0 0"
        />
      }
    </span>
  );
}

OfferStatusPill.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};